<template>
    <div class="position-relative" ref="topPage">
        <h3 class="text-center">Ottimo! Hai finito di impostare il tuo abbonamento!</h3>
        <p class="text-center mb-6">Seleziona i piatti che vuoi ricevere. Potrai cambiarli in seguito durante l’abbonamento</p>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center text-primary me-2">
                <span class="icon-ico-clock fs-5"></span>
            </span>	
            <span class="fs-xs font-alt">
                <span>Durata</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span>{{ durata }}</span>
            </span>
        </div>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center text-primary me-2">
                <span class="icon-ico-menutype fs-5"></span>
            </span>	
            <span class="fs-xs font-alt">
                <span>Tipo di menu</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span>{{ tipo }}</span>
            </span>
        </div>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center text-primary me-2">
                <span class="icon-ico-attributes fs-5"></span>
            </span>	
            <span class="fs-xs font-alt">
                <span>Obiettivi</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span>{{ obiettivi }}</span>
            </span>
        </div>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center text-primary me-2">
                <span class="icon-ico-attributes fs-5"></span>
            </span>	
            <span class="fs-xs font-alt">
                <span>Allergeni</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span>{{ allergeni }}</span>
            </span>
        </div>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center text-primary me-2">
                <span class="icon-ico-piatti fs-5"></span>
            </span>	
            <span class="fs-xs font-alt">
                <span>Piatti</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span><span class="text-primary">{{ piatti }}</span> di {{ nummandatory }} selezionati</span>
            </span>
        </div>

        <table class="products table table-sm align-middle mb-4 mt-2" cellspacing="0">
            <product-recap v-for="(product, ind) in selected" :prod="product" :key="'recap_'+ind" />
        </table>

        <div class="d-flex flex-column align-items-center">
            <button class="steplink stepnext btn btn-primary mb-2" v-if="!isUpdate" @click.prevent="buy">Acquista questo abbonamento</button>
            <button class="steplink stepnext btn btn-primary mb-2" v-else @click="update">Modifica questo abbonamento</button>
            <button class="steplink stepback btn btn-secondary" @click="backStep">Modifica</button>
        </div>

        <Loader v-if="loading" />

        <modal-success :dialog="openSuccess" :message="message" :cta="cta" @toggle="toggleModal" />
        <modal-error :dialog="openError" :message="message" @toggle="toggleModal" />

    </div>
</template>

<script>
import Loader from '@/components/Loader';
import ProductRecap from '@/components/parts/ProductRecap';
import ModalSuccess from '@/components/modal/ModalSuccess';
import ModalError from '@/components/modal/ModalError';

import { mapActions } from 'vuex';

import { getData } from "@/api/ajax";

import {
    isNil, replace
} from "lodash";

export default {
    name: 'BuyStep',
    mixins: [getData],
    data() {
        return {
            loading: false,
            errorLoading: false,
            selected: this.$store.state.abbonamento.products,
            abbonamento: this.$store.state.abbonamento,
            url: null,
            message: null,
            cta: null,
            openSuccess: false,
            openError: false
        }
    },
    computed: {
        durata() {
            const subscriptions = this.$store.state.subscriptions;
            const subscription = this.$store.state.abbonamento.subscription;

            if (isNil(subscriptions))
                return '';

            let varobj = subscriptions.filter(varo => varo.id == subscription);

            if (varobj.length > 0) {
                return varobj[0].name;
            } else {
                return '';
            }
        },
        tipo() {

            const variations = this.$store.state.variations;
            const variation = this.$store.state.abbonamento.variation;

            if (isNil(variation))
                return '';

            let varobj = variations.filter(varo => varo.id == variation);

            if (varobj.length > 0) {
                return replace(varobj[0].piano, '-', ' ');
            } else {
                return '';
            }
        },
        obiettivi() {
            const ob = this.$store.state.abbonamento.obiettivi.length;
            if (ob < 1) return 'Nessuno';
            return ob > 1 ? ob + ' selezionati' : ob + ' selezionato';
        },
        allergeni() {
            const al = this.$store.state.abbonamento.allergeni.length;
            if (al < 1) return 'Nessuno';
            return al > 1 ? al + ' selezionati' : al + ' selezionato';
        },
        piatti() {
            if (this.selected.length > 0)
                return this.selected.map(i => i.quantity).reduce((a, b) => a + b);
            else
                return 0;
        },
        ndays() {
            const variations = this.$store.state.variations;
            const variation = this.$store.state.abbonamento.variation;

            let varobj = variations.filter(varo => varo.id == variation);

            if (varobj.length > 0) {
                return varobj[0].piano.split('-');
            } else {
                return ['half', 5];
            }
        },
        nummandatory() {
            const days = parseInt(this.ndays[1]);
            const timeDay = this.ndays[0] == 'half' ? 1 : 2;
            return days + (days * timeDay);
        }
    },
    components: {
        Loader,
        ProductRecap,
        ModalSuccess,
        ModalError
    },
    methods: {
        ...mapActions([
            'close'
        ]),
        backStep() {
            this.$emit("update", {
                back: true
            });
            return;
        },
        toggleModal({ redirect = true, dialog = false }){
            this.log(redirect, dialog);
            
            if(!isNil(dialog)){
                this.openSuccess = dialog;
                this.openError = dialog;
            }
            if(!isNil(redirect) && redirect == true){
                this.close();
                window.location.href = this.url;                
            }
            
        },
        async update(){
            this.loading = true;
            try {
                
                const update = await this.updateAbbonamento(this.abbonamento);
                this.log(update);
                const data = update.data;

                if (data.result) {
                    this.url = data.url;
                    this.message = data.message;
                    this.cta = "Vai al tuo account";
                    this.openSuccess = true;
                    this.openError = false;
                    this.$refs.topPage.scrollIntoView({ behavior: "smooth" });
                    setTimeout(() => {
                        this.toggleModal({ redirect: true, dialog: false });
                    }, 5000);
                } else {
                    this.message = data.message;
                    this.openSuccess = false;
                    this.openError = true;
                }

                this.loading = false;

            } catch (e) {
                this.loading = false;
                this.log(e);
            }
        },
        async buy() {
            this.loading = true;
            try {
                const buy = await this.addToCart(this.abbonamento);
                this.log(buy);
                const data = buy.data;

                if(data.result){
                    let productprice = data.price;
                    const product_data = {
                        'name': data.name,
                        'id': this.abbonamento.subscription,
                        'price': Number(productprice).toFixed(2),
                        'category': data.product_cat,
                        'variant': this.abbonamento.variation,
                        'stocklevel': '',
                        'brand': '',
                        'quantity': 1
                    };
                    // this.$gtm.trackEvent({
                    //     event: 'add_to_cart',
                    //     ecommerce: {
                    //         currency: data.currency,
                    //         value: Number(productprice).toFixed(2),
                    //         items: [this.GTM_to_ga4(product_data)]
                    //     }
                    // });
                    if(window.gtm4wp_datalayer_name){
                        window[window.gtm4wp_datalayer_name].push({
                            'event': 'add_to_cart',
                            'ecommerce': {
                                'currency': data.currency,
                                'value': Number(productprice).toFixed(2),
                                'items': [this.GTM_to_ga4(product_data)]
                            }
                        });
                    }

                    this.url = data.url;
                    this.message = data.message;
                    this.cta = "Vai al carrello";
                    this.openSuccess = true;
                    this.openError = false;
                    this.$refs.topPage.scrollIntoView({ behavior: "smooth" });
                    setTimeout(() => {
                        this.toggleModal({redirect:true,dialog:false});
                    }, 5000);
                }else{
                    this.message = data.message;
                    this.openSuccess = false;
                    this.openError = true;
                }

                this.loading = false;
            } catch (e) {
                this.loading = false;
                this.log(e);
            }
        
        }
    },
    mounted() {
        this.GTM_trackView("Step riepilogo", "/abbonamento#step5");
    }
}
</script>

<style lang="scss" scoped>
table{
        width: 100%;
    }
</style>